"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiListItemTextThemeOptions = void 0;
exports.MuiListItemTextThemeOptions = {
    defaultProps: {
        primaryTypographyProps: {
            variant: "smallTextLabels",
        },
        secondaryTypographyProps: {
            variant: "microText",
        },
    },
};
